import { DOCUMENT,  } from "@angular/common";
import { Inject, Injectable, Renderer2, RendererFactory2 } from "@angular/core";
import { environment } from "../../../environments/environment";
import { Observable, Subject } from 'rxjs';

declare var Tawk_API: any;

@Injectable({
  providedIn: 'root'
})

export class TawktoService {

	userTxt: string;
	private loaded: boolean;
	private renderer: Renderer2;
    private loadSubject: Subject<boolean> = new Subject<boolean>();

	constructor(private rendererFactory: RendererFactory2, @Inject(DOCUMENT) private _document: Document) { 
        this.renderer = rendererFactory.createRenderer(null, null);
        //this.load();
	}

	private load(){
        if(this.loaded)
            return;

        const s = this.renderer.createElement('script');
        s.type = 'text/javascript';
        s.text = `var Tawk_API = Tawk_API || {},
					Tawk_LoadStart = new Date();
				function run() {
					(function () {
						var s1 = document.createElement("script"),
							s0 = document.getElementsByTagName("script")[0];
						s1.async = true;
						s1.src = "https://embed.tawk.to/5fb482db1535bf152a570d4e/default";
						s1.charset = "UTF-8";
						s1.setAttribute("crossorigin", "*");
						s0.parentNode.insertBefore(s1, s0);
					})();
					
				} run();`;
        this.renderer.appendChild(this._document.body, s);
        Tawk_API.onLoad = this.loadedEvent.bind(this);
    }

    private loadedEvent(){
	    this.loaded = true;
	    this.loadSubject.next(this.loaded);
	}

	public UpdateTawkUser(user: any) {
	    this.loadedWrapper(() => {this.updateAtrributes(user)});
	}

	private loadedWrapper(func: any){ 
	    if(!this.loaded){
	        var sub = this.loadSubject.asObservable().subscribe({
	            next: () => {
	                func();
	                sub.unsubscribe();
	            },
	            error: () => {}
	            });
	    } else {
	        func();
	    }
	}

	private updateAtrributes(user: any){
		
		if(environment.production){
			this.userTxt = user.nama + ' | ' + user.m_perusahaan.nama;
		}else{
			this.userTxt = user.nama;
		}

	    Tawk_API.setAttributes({
	        'name'  : this.userTxt,
	        'email' : user.email,
	        'id'  : user.client + user.id,
	    }, function(error){});
	}

	public SetChatVisibility(show: boolean = false) {
        this.UpdateTawkUser(() => show ? Tawk_API.showWidget() : Tawk_API.hideWidget());
    }
}
